<script setup lang="ts">
import { ItemInfoProps, useItemInfoComposable } from '@components/composables/item-info-composable.js';
import ExpandableImage from '@components/expandable-image.vue';
import CenterChildrenWrapper from '@components/layout-wrapper/center-children-wrapper.vue';
import ItemLoader from '@components/loader/item-loader.vue';

const { border = true, aspectRatio, size } = defineProps<ItemInfoProps & {
    border?: boolean,
    aspectRatio?: '1:1'|'4:3'|'16:9'|'5:1'|false,
    size?: 'xxs'|'xs'|'s'|'m'|'l'|false,
}>();

const { product, loading } = useItemInfoComposable();
</script>

<template>
    <ExpandableImage
        v-if="!loading"
        base-path="/products/830x622c"
        :border="border"
        :path="product.productAbstract.defaultImage?.path ?? null"
        :size="size"
        :aspect-ratio="aspectRatio"
    />
    <CenterChildrenWrapper v-else>
        <ItemLoader size="small" static-loader/>
    </CenterChildrenWrapper>
</template>
